import { ArrowStyleTypes, LineWidgetDashArrayTypes } from '../common/CommonLine.types';
import { LineIconType, LineIconWidgetData } from './LineIconWidget.types';

const DEFAULT_STROKE_WIDTH = 5;
const DEFAULT_STROKE_COLOR = '#000000';
const DEFAULT_STROKE_DASH_TYPE = LineWidgetDashArrayTypes.solid;
const DEFAULT_ARROW_STYLE = ArrowStyleTypes.none;

const DEFAULT_QUARTER_CURVE_DATA = {
  widthPx: 100,
  heightPx: 100,

  strokeWidth: DEFAULT_STROKE_WIDTH,
  strokeColor: DEFAULT_STROKE_COLOR,
  strokeDashType: DEFAULT_STROKE_DASH_TYPE,
  startArrowStyle: DEFAULT_ARROW_STYLE,
  endArrowStyle: DEFAULT_ARROW_STYLE,
};

const DEFAULT_HALF_CURVE_DATA = {
  widthPx: 100,
  heightPx: 50,

  strokeWidth: DEFAULT_STROKE_WIDTH,
  strokeColor: DEFAULT_STROKE_COLOR,
  strokeDashType: DEFAULT_STROKE_DASH_TYPE,
  startArrowStyle: DEFAULT_ARROW_STYLE,
  endArrowStyle: DEFAULT_ARROW_STYLE,
};

export const DEFAULT_LINE_ICON_DATA = {
  [LineIconType.HalfCurve]: DEFAULT_HALF_CURVE_DATA,
  [LineIconType.QuarterCurve]: DEFAULT_QUARTER_CURVE_DATA,
};

/**
 * Map of E1 icon IDs from shapev4 widget to line icon types and their default data
 * Used by icon widget menu
 */
export const E1_ICON_ID_TO_LINE_ICON_TYPE_MAP: {
  [key: string]: { type: LineIconType; data: Partial<LineIconWidgetData> };
} = {
  'vg-icon-quarter-curve': {
    type: LineIconType.QuarterCurve,
    data: DEFAULT_QUARTER_CURVE_DATA,
  },
  'vg-icon-quarter-curve-dotted': {
    type: LineIconType.QuarterCurve,
    data: {
      ...DEFAULT_QUARTER_CURVE_DATA,
      strokeDashType: LineWidgetDashArrayTypes.dotted,
    },
  },
  'vg-icon-quarter-curve-arrow': {
    type: LineIconType.QuarterCurve,
    data: {
      ...DEFAULT_QUARTER_CURVE_DATA,
      startArrowStyle: ArrowStyleTypes.long,
    },
  },
  'vg-icon-quarter-curve-arrow-dotted': {
    type: LineIconType.QuarterCurve,
    data: {
      ...DEFAULT_QUARTER_CURVE_DATA,
      startArrowStyle: ArrowStyleTypes.long,
      strokeDashType: LineWidgetDashArrayTypes.dotted,
    },
  },
  'vg-icon-quarter-curve-double-arrow': {
    type: LineIconType.QuarterCurve,
    data: {
      ...DEFAULT_QUARTER_CURVE_DATA,
      startArrowStyle: ArrowStyleTypes.long,
      endArrowStyle: ArrowStyleTypes.long,
    },
  },
  'vg-icon-quarter-curve-double-arrow-dotted': {
    type: LineIconType.QuarterCurve,
    data: {
      ...DEFAULT_QUARTER_CURVE_DATA,
      startArrowStyle: ArrowStyleTypes.long,
      endArrowStyle: ArrowStyleTypes.long,
      strokeDashType: LineWidgetDashArrayTypes.dotted,
    },
  },
  'vg-icon-half-curve': {
    type: LineIconType.HalfCurve,
    data: DEFAULT_HALF_CURVE_DATA,
  },
  'vg-icon-half-curve-dotted': {
    type: LineIconType.HalfCurve,
    data: {
      ...DEFAULT_HALF_CURVE_DATA,
      strokeDashType: LineWidgetDashArrayTypes.dotted,
    },
  },
  'vg-icon-half-curve-arrow': {
    type: LineIconType.HalfCurve,
    data: {
      ...DEFAULT_HALF_CURVE_DATA,
      startArrowStyle: ArrowStyleTypes.long,
    },
  },
  'vg-icon-half-curve-arrow-dotted': {
    type: LineIconType.HalfCurve,
    data: {
      ...DEFAULT_HALF_CURVE_DATA,
      startArrowStyle: ArrowStyleTypes.long,
      strokeDashType: LineWidgetDashArrayTypes.dotted,
    },
  },
  'vg-icon-half-curve-double-arrow': {
    type: LineIconType.HalfCurve,
    data: {
      ...DEFAULT_HALF_CURVE_DATA,
      startArrowStyle: ArrowStyleTypes.long,
      endArrowStyle: ArrowStyleTypes.long,
    },
  },
  'vg-icon-half-curve-double-arrow-dotted': {
    type: LineIconType.HalfCurve,
    data: {
      ...DEFAULT_HALF_CURVE_DATA,
      startArrowStyle: ArrowStyleTypes.long,
      endArrowStyle: ArrowStyleTypes.long,
      strokeDashType: LineWidgetDashArrayTypes.dotted,
    },
  },
};
